import {
  ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_COMPONENT,
} from '../../constants/actions';

export const fetchComponentsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION,
});

export const fetchComponentsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION,
  payload: data,
});

export const getComponentInitAction = () => ({
  type: ACT_INSTANCES_GET_COMPONENT_INIT_ACTION,
});

export const getComponentSuccessAction = data => ({
  type: ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION,
  payload: data,
});

export const addComponentInitAction = data => ({
  type: ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION,
  payload: data,
});

export const addComponentSuccessAction = data => ({
  type: ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION,
  payload: data,
});

export const deleteComponentInitAction = id => ({
  type: ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION,
  payload: id,
});

export const deleteComponentSuccessAction = () => ({
  type: ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION,
});

export const updateComponentsFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS,
  payload: filters,
});

export const updateSelectedComponentAction = component => ({
  type: ACT_INSTANCES_SET_SELECTED_COMPONENT,
  payload: component,
});
